<button type="button" class="btn btn-primary fab-filter-extended shadow-lg" (click)="toggleOffcanvas()">
  <i class="bi bi-funnel-fill fs-5"></i>
  <span>Filtra</span>
</button>

<div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample">

  <!-- HEADER -->
  <div class="offcanvas-header pb-0 d-flex justify-content-between w-100">
    <h5 class="fw-bold">Filtri</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
  </div>

  <!-- SEARCH -->
  <div class="px-3 pb-2">
    <div class="search-box">
      <i class="bi bi-search"></i>
      <input type="text" class="form-control search-input" placeholder="Cerca filtri…" [(ngModel)]="globalSearch" />

      @if (globalSearch) {
      <button class="btn-clear" type="button" (click)="globalSearch = ''">
        <i class="bi bi-x-circle-fill"></i>
      </button>
      }
    </div>
  </div>

  <!-- BODY -->
  <div class="offcanvas-body d-flex flex-column justify-content-between">

    <div class="list-group">

      @for (dd of dropdownConfig; track dd.key) {

      @if (dd.key === 'dateRange' || (dd.key)) {

      <!-- DROPDOWN HEADER -->
      <button class="list-group-item list-group-item-action
                   d-flex justify-content-between align-items-center mb-3" (click)="toggleDropdown(dd.key)">
        {{ dd.title }}
        <i class="bi bi-chevron-down icon-rotate" [class.rotate]="isDropdownOpen(dd.key) || globalSearch">
        </i>
      </button>

      @if (isDropdownOpen(dd.key) || globalSearch) {

      <!-- DATE RANGE -->
      @if (dd.key === 'dateRange') {

      <div class="dropdown-content p-3 dropdown-date show">
        <div class="date-grid">

          <div class="date-field">
            <span class="date-label">Da</span>
            <input type="date" class="date-input" [ngModel]="vm.startDate" (ngModelChange)="onStartDateChange($event)"
              [max]="vm.endDate || null" />
          </div>

          <div class="date-field">
            <span class="date-label">A</span>
            <input type="date" class="date-input" [ngModel]="vm.endDate" (ngModelChange)="onEndDateChange($event)"
              [min]="vm.startDate || null" />
          </div>

        </div>

        @if (vm.startDate || vm.endDate) {
        <button class="date-clear mt-2" type="button" (click)="clearDateRange()">
          <i class="bi bi-x-circle-fill"></i>
          <span>Pulisci</span>
        </button>
        }
      </div>

      } @else {

      <!-- OPTIONS -->
      <div class="dropdown-content p-2 show">
        <div class="scrollable-list">

          @for (opt of getFilteredOptions(dd.key); track opt.id) {
          <label class="dropdown-item d-flex align-items-center gap-2" [class.search-match]="globalSearch">

            <input type="checkbox" [checked]="opt.selected"
              (change)="onToggleOption(dd.key, opt, $event.target.checked)" />

            {{ opt.label }}
          </label>
          }

        </div>
      </div>

      }
      }
      }
      }
    </div>

    <!-- RESET -->
    <div>
      <input type="button" class="btn btn-primary reset-all-btn w-100" value="Reset filtri" (click)="resetAll()" />
    </div>

  </div>
</div>